import firebase from "firebase/app";
import "firebase/auth";
import "firebase/database";

const config = {
  apiKey: "AIzaSyDCH5v2-Qp5rR5lt3bQCxRd0Fv845Na4Q8",
  authDomain: "tbcexchanger-23565.firebaseapp.com",
  databaseURL: "https://tbcexchanger-23565.firebaseio.com",
  projectId: "tbcexchanger-23565",
  storageBucket: "tbcexchanger-23565.appspot.com",
  messagingSenderId: "182141853395"
};

const conGteToken = "bczDY9C4U-xdd8xf7mAs6okiuJgWwX_r8sR6Dz32";
const PAY_BEAR = "sec35d3c9acb5953cab40d47371ca3ab38c";
const fire = firebase.initializeApp(config);

export { conGteToken, PAY_BEAR };
export default fire;



// WEBPACK FOOTER //
// ./src/config/config.js